<template>
  <v-content>
    <v-container>
      <list
        ref="list"
        :title="title"
        :headers="headers"
        :data="data"
        :response="response"
        :loading="loading"
        :canUserDelete="canUserDelete"
        @edit="editFn"
        @delete="deleteFn"
        @details="previewFn"
        @new="newFn"
        @reload="loadServiceProviders()"
        @hook:mounted="handleMount('list')"
      />
      <delete-dialog
        :dialog="deleteDialog"
        :item="itemName"
        @agree="remove"
        v-show="false"
      />
    </v-container>
  </v-content>
</template>

<script>
import api from "@/utils/api.js";
import List from "@/components/lists/BuilderList.vue";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import snackbar from "@/utils/snackbar.js";
export default {
  components: {
    List,
    DeleteDialog,
  },
  data: () => ({
    mounted: {
      list: { mounted: false, refs: "list" },
      root: { mounted: false, refs: null },
    },
    headers: [],
    data: [],
    sort: "name",
    title: "Service Partners",
    loading: true,
    response: null,
    itemName: null,
    deleteDialog: false,
    canUserDelete: true,
  }),
  created() {
    this.setInitialData();
  },

  mounted() {
    //NOTE: this is here to prevent multiple API calls to the same function. To gether all the parameters from the different components.
    this.handleMount("root");
  },

  methods: {
    handleMount(componentName) {
      if (!this.mounted.hasOwnProperty(componentName)) {
        console.error(
          "SERVICE PROVIDER:component name does not exists",
          componentName
        );
        return;
      }

      this.mounted[componentName] = {
        ...this.mounted[componentName],
        mounted: true,
      };

      if (Object.values(this.mounted).every((item) => item.mounted)) {
        this.loadServiceProviders();
      }
    },
    setInitialData() {
      this.headers = [
        {
          text: this.$t("users.serviceProviders.name"),
          align: "left",
          sortable: false,
          value: "name",
        },
        {
          text: this.$t("users.serviceProviders.vendors"),
          align: "left",
          sortable: false,
          value: "vendors",
        },
        {
          text: this.$t("users.serviceProviders.domains"),
          align: "left",
          sortable: false,
          value: "domains",
        },
        {
          text: this.$t("users.serviceProviders.country"),
          align: "left",
          sortable: false,
          value: "country",
        },
        {
          text: this.$t("users.serviceProviders.city"),
          align: "left",
          sortable: false,
          value: "city",
        },
        {
          text: this.$t("users.serviceProviders.actions"),
          align: "right",
          value: "action",
          sortable: false,
        },
      ];

      this.title = this.$t("users.serviceProviders.servicePartners");
    },
    loadServiceProviders() {
      let params = {};

      for (const key in this.mounted) {
        const refs = this.mounted[key].refs;
        if (refs == null) continue;
        params = {
          ...params,
          ...this.$refs[refs].query,
        };
      }

      this.$router.replace({
        name: this.$route.name,
        query: params,
      });

      this.loading = true;
      this.data = [];
      api.getServiceProviderList(params).then((resp) => {
        this.response = resp.data;
        this.data = resp.data.results;
        this.canUserDelete = this.data.length > 1;
        this.loading = false;
      });
    },
    editFn(dealer) {
      this.$router.push({
        name: "serviceProviderEdit",
        params: { id: dealer.uuid, tab: "info" },
      });
    },
    deleteFn(item) {
      this.deleteDialog = true;
      this.item = item;
      this.itemName = item.name;
    },
    remove(agreed) {
      if (agreed) {
        api.deleteServiceProvider(this.item.uuid).then((resp) => {
          snackbar.success(
            this.$t("utils.snackbar.success.successfullyDeleted")
          );
          this.loadServiceProviders();
        });
      }
      this.deleteDialog = false;
    },
    previewFn(dealer) {
      this.$router.push({
        name: "serviceProviderDetails",
        params: { id: dealer.uuid },
      });
    },
    newFn(item) {
      this.$router.push({
        name: "serviceProviderNew",
        params: { tab: "info" },
      });
    },
  },
};
</script>
